import React from 'react';
import Container from '../../core/layout/Layout/Container';
import Heading from '../../core/typography/Heading';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { PromoBannerQuery } from '../../../../generated/graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import Button from '../../core/buttons/Button';
import useDatalayer from '../../../../hooks/use-datalayer';

const PromoBanner2 = ({
  backgroundClassName,
}: {
  backgroundClassName?: string;
}) => {
  const datalayer = useDatalayer();
  const data = useStaticQuery<PromoBannerQuery>(graphql`
    query PromoBanner2 {
      image: file(relativePath: { eq: "UGO_Chiamata.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
        }
      }
    }
  `);
  return (
    <div className={backgroundClassName}>
      <div
        className="pt-20 pb-10 overflow-hidden"
        style={{
          backgroundImage: 'linear-gradient(-94deg, #68dec2 0%, #188877 100%)',
        }}
      >
        <Container>
          <div className="flex relative">
            <div className="z-10">
              <Heading
                variant="h3"
                className="text-white mb-2"
                style={{ color: '#ffffff' }}
              >
                Vuoi conoscere il Team UGO?
              </Heading>
              <Heading
                variant="h5"
                className="md:w-2/3 text-white mb-10"
                style={{ color: '#ffffff' }}
              >
                <p className="hidden md:block p-0 m-0">
                  Prenota un appuntamento telefonico gratuito con il nostro
                  Customer Service che ogni giorno ascolta e risponde ai bisogni
                  dei nostri utenti.
                </p>
                <p className="md:hidden p-0 m-0">
                  Prenota un appuntamento telefonico gratuito con il nostro
                  Customer Service.
                </p>
              </Heading>
              <a
                target="_blank"
                rel="noreferrer"
                className="font-bold underline"
                href="https://hellougo.typeform.com/info-request-cc?utm_content=greenbar&typeform-source=hellougo.com"
              >
                <Button variant="filled" color="primary">
                  Prenota subito
                </Button>
              </a>
            </div>
            <div className="w-full md:w-5/6 absolute right-0 -bottom-12">
              <GatsbyImage
                image={data.image.childImageSharp.gatsbyImageData}
                alt="UGO Chiamata"
                className="w-full"
              />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default PromoBanner2;
